/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./liveBuy.vue?vue&type=template&id=79d75964&scoped=true&"
import script from "./liveBuy.vue?vue&type=script&lang=js&"
export * from "./liveBuy.vue?vue&type=script&lang=js&"
import style0 from "./liveBuy.vue?vue&type=style&index=0&id=79d75964&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79d75964",
  null
  
)

export default component.exports